module.exports = __webpack_public_path__ + "img/icon-arrow-left-active.9aa01e03.svg";